export default "precision highp float;\r\nprecision highp int;\r\n\r\nvoid main() {\r\n    discard;\r\n}\n\n";